const MIME_VS_EXTENSION = {
  'text/plain': '.txt',
  'text/html': '.html',
  'text/css': '.css',
  'application/javascript': '.js',
  'application/json': '.json',
  'application/xml': '.xml',
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/bmp': '.bmp',
  'image/svg+xml': '.svg',
  'audio/mpeg': '.mp3',
  'audio/wav': '.wav',
  'audio/ogg': '.ogg',
  'video/mp4': '.mp4',
  'video/webm': '.webm',
  'video/quicktime': '.mov',
  'application/pdf': '.pdf',
  'application/msword': '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  'application/vnd.ms-excel': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
  'application/zip': '.zip',
  'application/x-tar': '.tar',
  'application/x-gzip': '.gz',
  'application/x-bzip2': '.bz2',
  'text/csv': '.csv',
  'application/rtf': '.rtf'
};
export const readAsDataURL = file => {
  return new Promise((accept, fail) => {
    const reader = new FileReader();
    reader.onload = () => accept(reader.result);
    reader.onerror = () => fail(reader.error);
    reader.readAsDataURL(file);
  });
};
export const processBase64Data = base64Content => {
  const base64ContentArray = base64Content === null || base64Content === void 0 ? void 0 : base64Content.split(',');
  if (base64Content && base64ContentArray.length >= 2) {
    const mimeType = base64ContentArray[0].match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0];
    const base64Data = base64ContentArray[1];
    const fileExtension = mimeType.split('/')[1];
    return {
      mimeType,
      fileExtension,
      base64Data
    };
  }
  return {};
};
export const isBase64DataURL = dataUrl => {
  if (dataUrl.startsWith('data:') && dataUrl.includes(';base64,')) {
    return true;
  }
  return false;
};
export const getBlobFromDataURL = dataUrl => {
  const {
    base64Data,
    mimeType
  } = processBase64Data(dataUrl);
  const uint8Array = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
  return new Blob([uint8Array], {
    type: mimeType
  });
};
export const getFileExtensionByMimeType = mimeType => MIME_VS_EXTENSION[mimeType] || '';